import React from "react";
import { Button } from "./Button";

type HeroGoalOption = {
  label: string;
  icon: string;
  [key: string]: unknown;
};

type Props = {
  options: HeroGoalOption[];
  selectedLabel: string;
  submitting?: boolean;
  onSelect: (option: HeroGoalOption) => void;
};

export const HeroGoalOptions: React.FC<Props> = ({
  options,
  selectedLabel,
  submitting = false,
  onSelect,
}) => (
  <div className="help-options-grid">
    {options.map((option) => {
      const isSelected = selectedLabel === option.label;
      return (
        <Button
          key={option.label}
          type="button"
          onClick={() => onSelect(option)}
          ariaPressed={isSelected}
          disabled={submitting}
          className={`help-option-card ${isSelected ? "is-selected" : ""}`}
          variant="unstyled"
          text={option.label}
        >
          <div className="help-icon">
            <img
              src={option.icon}
              alt=""
              className="icon-image"
              aria-hidden="true"
            />
          </div>
          <p className="help-text">{option.label}</p>
        </Button>
      );
    })}
  </div>
);
